import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function dispose() {
}
var HttpInterceptorClass;
function HttpInterceptor() {
  if (HttpInterceptorClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'HttpInterceptor', VOID, VOID, VOID, [2]);
    HttpInterceptorClass = $;
  }
  return HttpInterceptorClass;
}
var DefaultHttpInterceptorChainClass;
function DefaultHttpInterceptorChain() {
  if (DefaultHttpInterceptorChainClass === VOID) {
    class $ {
      constructor(interceptors, index) {
        this.v67_1 = interceptors;
        this.w67_1 = index;
      }
      x67(request, $completion) {
        // Inline function 'kotlin.check' call
        if (!(this.w67_1 < this.v67_1.v2())) {
          throw IllegalStateException().o('Check failed.');
        }
        return this.v67_1.w2(this.w67_1).u67(request, new (DefaultHttpInterceptorChain())(this.v67_1, this.w67_1 + 1 | 0), $completion);
      }
    }
    initMetadataForClass($, 'DefaultHttpInterceptorChain', VOID, VOID, VOID, [1]);
    DefaultHttpInterceptorChainClass = $;
  }
  return DefaultHttpInterceptorChainClass;
}
//region block: exports
export {
  DefaultHttpInterceptorChain as DefaultHttpInterceptorChain22k3s5gesb9pu,
  dispose as dispose2t7a37uqicel0,
  HttpInterceptor as HttpInterceptor2khzkwmar9lg6,
};
//endregion

//# sourceMappingURL=HttpInterceptor.mjs.map
